/* eslint-disable react/sort-comp */
/* eslint-disable react/no-unused-class-component-methods */
import { PAGE_SIZE } from 'Constants/webchat';
import { arrayOf, func, number, shape } from 'prop-types';
import { PureComponent } from 'react';
import { connect } from 'react-redux';
import * as Actions from 'Redux/modules/webChat/actions';
import { getListCert } from 'Redux/modules/webChat/emc/actions';
import { getConversationById } from 'Selectors/webChat/common';
import { Segment } from 'semantic-ui-react';

import ContextMenuHeader from '../ContextMenuHeader';

import AllMedia from './AllMedia/AllMedia';
import styles from './AttachmentFiles.less';
import AttachmentTabs from './AttachmentTabs';
import FileList from './FileList/FileList';
import MedicalCertificate from './MedicalCertificate/MedicalCertificate';
import Memo from './Memo/Memo';
import PrescriptionOrder from './PrescriptionOrder/PrescriptionOrder';
import ReferralMemos from './ReferallMemo/ReferralMemos';

class AttachmentFiles extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      activeMedia: false,
      activeMedical: false,
      activeMemo: false,
      activeReferralMemo: false,
    };
  }

  toggleMedia = () => {
    this.setState(preState => ({ activeMedia: !preState.activeMedia }));
  };

  toggleMedical = () => {
    this.setState(preState => ({ activeMedical: !preState.activeMedical }));
  };

  toggleMemo = () => {
    this.setState(preState => ({ activeMemo: !preState.activeMemo }));
  };

  toggleReferralMemo = () => {
    this.setState(preState => ({ activeReferralMemo: !preState.activeReferralMemo }));
  };

  componentDidMount() {
    const {
      getListPrescriptionOrders,
      getListCert: getListCertAction,
      conversationActiveId,
      conversationActive,
      getReferralMemos,
      getMemos,
      getAllMedia,
      getFiles,
      activeClinicTab,
    } = this.props;
    getListCertAction({
      patientId: conversationActive?.latestConsult?.forPatient?.id,
      clinicId: activeClinicTab,
    });
    getListPrescriptionOrders({
      status: 1,
      byPatientId: conversationActive?.latestConsult?.patient?.id,
      forPatientId: conversationActive?.latestConsult?.forPatient?.id,
      clinicId: activeClinicTab,
    });
    if (conversationActiveId) {
      getReferralMemos(conversationActiveId, { page: 1, pageSize: PAGE_SIZE });
      getMemos(conversationActiveId, { page: 1, pageSize: PAGE_SIZE });
      getAllMedia({ conversationId: conversationActiveId, count: PAGE_SIZE });
      getFiles({ conversationId: conversationActiveId, count: PAGE_SIZE });
    }
  }

  render() {
    const {
      closeContextMenu,
      allMedia,
      certification,
      memo,
      getAllMedia,
      conversationActiveId,
      referralMemo,
      conversationActive,
      prescription,
      getListCert: getListCertAction,
      file,
      activeClinicTab,
    } = this.props;
    const { activeMedia, activeMemo, activeReferralMemo } = this.state;
    const {
      meta: {
        pagination: { total: totalCert },
      },
    } = certification;
    const totalMemo = memo.meta?.pagination.total || 0;
    const totalMedia = allMedia?.meta?.totalMedia || 0;
    const totalReferralMemo = referralMemo.metaReferralMemos?.pagination.total || 0;
    const totalPrescription = prescription?.meta?.pagination?.total || 0;
    const totalFile = file.meta?.pagination?.total || 0;

    const tabs = [
      {
        id: 'mc',
        name: `MC (${totalCert})`,
        component: (
          <div className={styles.tabContent}>
            <MedicalCertificate
              certification={certification}
              getListCert={getListCertAction}
              patientId={conversationActive?.latestConsult?.forPatient?.id}
              activeClinicTab={activeClinicTab}
            />
          </div>
        ),
      },
      {
        id: 'prescription',
        name: `Prescription (${totalPrescription})`,
        component: (
          <div className={styles.tabContent}>
            <PrescriptionOrder
              byPatientId={conversationActive?.latestConsult?.patient?.id}
              forPatientId={conversationActive?.latestConsult?.forPatient?.id}
            />
          </div>
        ),
      },
      {
        id: 'referral',
        name: `Referral (${totalReferralMemo})`,
        component: (
          <div className={styles.tabContent}>
            <ReferralMemos conversationId={conversationActiveId} isCollapsed={activeReferralMemo} />
          </div>
        ),
      },
      {
        id: 'memo',
        name: `Memo (${totalMemo})`,
        component: (
          <div className={styles.tabContent}>
            <Memo conversationId={conversationActiveId} isCollapsed={activeMemo} />
          </div>
        ),
      },
      {
        id: 'media',
        name: `Media (${totalMedia})`,
        component: (
          <div className={styles.tabContent}>
            <AllMedia
              allMedia={allMedia}
              getAllMedia={getAllMedia}
              isCollapsed={activeMedia}
              conversationId={conversationActiveId}
            />
          </div>
        ),
      },
      {
        id: 'files',
        name: `File (${totalFile})`,
        component: (
          <div className={styles.tabContent}>
            <FileList conversationId={conversationActiveId} />
          </div>
        ),
      },
    ];

    return (
      <Segment.Group className="context-menu">
        <ContextMenuHeader title="Attached files" goBack={closeContextMenu} />
        <div className="body" style={{ backgroundColor: '#fff' }}>
          <AttachmentTabs tabs={tabs} />
        </div>
      </Segment.Group>
    );
  }
}

AttachmentFiles.propTypes = {
  certification: shape({}).isRequired,
  allMedia: shape({}).isRequired,
  memo: shape({}).isRequired,
  referralMemo: shape({}).isRequired,
  getAllMedia: func.isRequired,
  getListCert: func.isRequired,
  closeContextMenu: func.isRequired,
  conversationActiveId: number.isRequired,
  conversationActive: shape({}).isRequired,
  getReferralMemos: func.isRequired,
  getMemos: func.isRequired,
  prescription: shape({}).isRequired,
  getListPrescriptionOrders: func.isRequired,
  file: arrayOf(shape({})).isRequired,
  getFiles: func.isRequired,
  activeClinicTab: number.isRequired,
};

const mapStateToProps = state => ({
  allMedia: state.webChat.allMedia,
  certification: state.webChat.emc.certification,
  memo: state.webChat.memo,
  referralMemo: state.webChat.referralMemo,
  conversation: state.webChat.conversation,
  prescription: state.webChat.prescription,
  file: state.webChat.file,
  conversationActive: getConversationById(state, state.webChat.conversationActive),
  activeClinicTab: state.webChat.commons.activeClinicTab,
});

const mapDispatchToProps = {
  getAllMedia: Actions.allMediaRetrieve,
  getListCert,
  getListPrescriptionOrders: Actions.getListPrescriptionOrders,
  getReferralMemos: Actions.getReferralMemos,
  getMemos: Actions.getMemos,
  getFiles: Actions.getFiles,
};

export default connect(mapStateToProps, mapDispatchToProps)(AttachmentFiles);
